import { EmployeeCalendarComponent } from './calendar.component';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr-Latn';
import localeHu from '@angular/common/locales/hu';
import localeEn from '@angular/common/locales/en-GB';
import localeUa from '@angular/common/locales/ru-UA';
const routes = [
    {
        path: 'calendar',
        component: EmployeeCalendarComponent
    }
];
registerLocaleData(localeSr);
registerLocaleData(localeHu);
registerLocaleData(localeEn);
registerLocaleData(localeUa);
const ɵ0 = adapterFactory;
export class EmployeeCalendarModule {
}
export { ɵ0 };
